import { startLoader, stopLoader } from '../store/actions/requestActions';
import instance from './AxiosConfig';
import * as actionTypes from '../store/types';
import { removeToken } from './storageData';

const logout = (dispatch) => {
    removeToken();
    window.location.reload();

    dispatch({
        type: actionTypes.LOGOUT
    });
};

export function put(dispatch, url, data, callBack, errorCallBack = (e) => {}) {
    //startLoader(dispatch);

    return instance
        .put(url, data)
        .then(response => callBack(response))
        .catch(error => {
            if (!!error && !!error.response && !!error.response.status && error.response.status == 401) {
                logout(dispatch);
            } else {
                errorCallBack(error)
            }
        })
        .finally(() => stopLoader(dispatch));
}

export function putNotLoader(dispatch, url, data, callBack, errorCallBack = (e) => {}) {
    return instance
        .put(url, data)
        .then(response => callBack(response))
        .catch(error => {
            if (!!error && !!error.response && !!error.response.status && error.response.status == 401) {
                logout(dispatch);
            } else {
                errorCallBack(error)
            }
        })
}

export function postNotLoader(dispatch, url, data, callBack, errorCallBack = (e) => {}) {
    instance
        .post(url, data)
        .then(response => callBack(response))
        .catch(error => {
            if (!!error && !!error.response && !!error.response.status && error.response.status == 401) {
                logout(dispatch);
            } else {
                errorCallBack(error)
            }
        })
}

export function post(dispatch, url, data, callBack, errorCallBack = (e) => {}) {
    startLoader(dispatch);

    instance
        .post(url, data)
        .then(response => callBack(response))
        .catch(error => {
            if (!!error && !!error.response && !!error.response.status && error.response.status == 401) {
                logout(dispatch);
            } else {
                errorCallBack(error)
            }
        })
        .finally(() => stopLoader(dispatch));
}

export function deleteReq(dispatch, url, config, callback) {
    startLoader(dispatch);

    instance
        .delete(url, config)
        .then(response => callback(response))
        .finally(() => stopLoader(dispatch));
}
